import common, { CdnDomain, type IichiEnv } from '@/js/lib/common';
import NoImage from '@/images/ui/1px-gray.png';

export const cdnDomain = (env: IichiEnv): CdnDomain => CdnDomain[env];

export const cdnUrl = (path: string, env: IichiEnv | undefined = undefined): string => `${cdnDomain(env || common.env.Pallet.iichiEnv)}${path}`;

export const dynamicImageUrl = (imagePath?: string, dimension?: { width?: number; height?: number }, env?: IichiEnv): string => {
  if (!imagePath) {
    return NoImage as string;
  }

  let resize = '';
  const { width, height } = dimension ?? {};

  if (width || height) {
    resize = '/r';

    if (width) {
      resize += `/w/${width}`;
    }

    if (height) {
      resize += `/h/${height}`;
    }
  }

  return cdnUrl(resize + imagePath, env);
};
